import {createSubmitRequestTypes} from "./helpers";

export const SET_AUTHORIZED = "AUTH:SET_AUTHORIZED";
export const setAuthorized = (user) => ({ type: SET_AUTHORIZED, user });
export const REQUEST_AUTHORIZATION = createSubmitRequestTypes("AUTH:REQUEST_AUTHORIZATION");
export const requestAuthorization = (passcode) => ({ type: REQUEST_AUTHORIZATION.SUBMIT, passcode });
